// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './Faq.css';

// const Faq = () => {
//   const [activeQuestion, setActiveQuestion] = useState(null);

//   const toggleQuestion = (index) => {
//     if (activeQuestion === index) {
//       setActiveQuestion(null);
//     } else {
//       setActiveQuestion(index);
//     }
//   };

//   const faqCategories = [
//     { id: 'ordering', label: 'Ordering' },
//     { id: 'delivery', label: 'Delivery' },
//     { id: 'product', label: 'Product Issues' },
//     { id: 'payment', label: 'Payment & Refunds' },
//     { id: 'account', label: 'Account' }
//   ];

//   const [activeCategory, setActiveCategory] = useState('ordering');

//   const faqQuestions = [
//     {
//       id: 1,
//       category: 'ordering',
//       question: 'How do I place an order?',
//       answer: 'You can place an order by browsing our products, adding items to your cart, and proceeding to checkout. Make sure you\'re logged in to your account, or create one if you don\'t have it yet. Follow the steps to provide shipping information and payment details to complete your order.'
//     },
//     {
//       id: 2,
//       category: 'ordering',
//       question: 'What areas do you serve?',
//       answer: 'We deliver to most locations across India. During checkout, you can select your location to check if we deliver to your area. We are constantly expanding our delivery network to reach more locations.'
//     },
//     {
//       id: 3,
//       category: 'ordering',
//       question: 'How long does it take to process my order?',
//       answer: 'Most orders are processed within 24 hours. Once your order is confirmed, you\'ll receive an email with tracking information.'
//     },
//     {
//       id: 4,
//       category: 'delivery',
//       question: 'What are the delivery charges?',
//       answer: 'Delivery charges vary based on your location and order value. Orders above ₹1000 qualify for free shipping to most locations. The exact delivery charge will be displayed during checkout.'
//     },
//     {
//       id: 5,
//       category: 'delivery',
//       question: 'How can I track my order?',
//       answer: 'Once your order is shipped, you\'ll receive a tracking number via email and SMS. You can also track your order from the "My Orders" section in your account.'
//     },
//     {
//       id: 6,
//       category: 'product',
//       question: 'What if I receive a defective product?',
//       answer: 'We have a 7-day replacement policy for defective products. Please contact our support team with your order details and we\'ll arrange for a replacement or refund.'
//     },
//     {
//       id: 7,
//       category: 'payment',
//       question: 'What payment methods do you accept?',
//       answer: 'We accept credit/debit cards, UPI, net banking, and cash on delivery (for orders under ₹10,000).'
//     },
//     {
//       id: 8,
//       category: 'payment',
//       question: 'How do I request a refund?',
//       answer: 'You can request a refund from the "My Orders" section by selecting the relevant order and clicking on "Request Refund". Refunds are processed within 5-7 business days.'
//     },
//     {
//       id: 9,
//       category: 'account',
//       question: 'How do I reset my password?',
//       answer: 'Click on "Login" and then "Forgot Password". Enter your registered email address, and we\'ll send you a password reset link.'
//     },
//   ];

//   return (
//     <div className="faq-container">

//         <div className="back-to-home-wrapper">
//                 <Link to="/" className="back-to-home-link">
//                     <svg
//                         className="back-arrow"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                         xmlns="http://www.w3.org/2000/svg"
//                     >
//                         <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth="2"
//                             d="M15 19l-7-7 7-7"
//                         />
//                     </svg>
//                     Back to Home
//                 </Link>
//             </div>
//       <div className="help-header">
//         <h1>How Can We Help You?</h1>
//         <p>Find answers to frequently asked questions or reach out to our support team</p>
//       </div>

//       <div className="support-options">
//         <div className="support-card">
//           <h3>Call Us</h3>
//           <div className="support-icon">
//             <i className="phone-icon"></i>
//           </div>
//           <div className="support-contact">
//             <p className="phone-number">+91 8722237574</p>
//             <p className="hours">7 AM - 9 PM, All days</p>
//           </div>
//         </div>

//         <div className="support-card">
//           <h3>Email Support</h3>
//           <div className="support-icon">
//             <i className="email-icon"></i>
//           </div>
//           <div className="support-contact">
//             <p className="email">official.procart@gmail.com</p>
//             <p className="response-time">Response within 24 hours</p>
//           </div>
//         </div>

//         <div className="support-card">
//           <h3>WhatsApp</h3>
//           <div className="support-icon">
//             <i className="whatsapp-icon"></i>
//           </div>
//           <div className="support-contact">
//             <p className="phone-number">+91 8722237574</p>
//             <p className="support-note">Quick support via WhatsApp</p>
//           </div>
//         </div>
//       </div>

//       <div className="faq-section">
//         <h2>Frequently Asked Questions</h2>

//         <div className="faq-content">
//           <div className="faq-categories">
//             {faqCategories.map(category => (
//               <div 
//                 key={category.id}
//                 className={`category-item ${activeCategory === category.id ? 'active' : ''}`}
//                 onClick={() => setActiveCategory(category.id)}
//               >
//                 {category.label}
//               </div>
//             ))}
//           </div>

//           <div className="faq-questions">
//             {faqQuestions
//               .filter(q => q.category === activeCategory)
//               .map((faq, index) => (
//                 <div className="faq-item" key={faq.id}>
//                   <div 
//                     className={`faq-question ${activeQuestion === faq.id ? 'active' : ''}`}
//                     onClick={() => toggleQuestion(faq.id)}
//                   >
//                     <p>{faq.question}</p>
//                     <span className="toggle-icon">{activeQuestion === faq.id ? '-' : '+'}</span>
//                   </div>
//                   {activeQuestion === faq.id && (
//                     <div className="faq-answer">
//                       <p>{faq.answer}</p>
//                     </div>
//                   )}
//                 </div>
//               ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Faq;



import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getFirestore, collection, getDocs, doc, getDoc } from 'firebase/firestore';
import './Faq.css';
import { FaSpinner, FaArrowLeft } from 'react-icons/fa';

const Faq = () => {
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [activeCategory, setActiveCategory] = useState('ordering');
  const [faqCategories, setFaqCategories] = useState([]);
  const [faqQuestions, setFaqQuestions] = useState([]);
  const [faqSettings, setFaqSettings] = useState({
    title: 'How Can We Help You?',
    subtitle: 'Find answers to frequently asked questions or reach out to our support team',
    supportContacts: {
      phone: {
        number: '+91 8722237574',
        hours: '7 AM - 9 PM, All days'
      },
      email: {
        address: 'official.procart@gmail.com',
        response: 'Response within 24 hours'
      },
      whatsapp: {
        number: '+91 8722237574',
        note: 'Quick support via WhatsApp'
      }
    }
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Firestore reference
  const db = getFirestore();
  const faqCollection = collection(db, 'faq');

  useEffect(() => {
    const fetchFaqData = async () => {
      try {
        // First get FAQ settings
        const settingsDoc = await getDoc(doc(db, 'settings', 'faq'));
        if (settingsDoc.exists()) {
          setFaqSettings({
            ...faqSettings,
            ...settingsDoc.data()
          });
        }

        // Get FAQ categories
        const categoriesDoc = await getDoc(doc(db, 'settings', 'faqCategories'));
        if (categoriesDoc.exists() && categoriesDoc.data().categories) {
          setFaqCategories(categoriesDoc.data().categories);
          // Set active category to first category if available
          if (categoriesDoc.data().categories.length > 0) {
            setActiveCategory(categoriesDoc.data().categories[0].id);
          }
        } else {
          // Fallback to default categories if none in database
          setFaqCategories([
            { id: 'ordering', label: 'Ordering' },
            { id: 'delivery', label: 'Delivery' },
            { id: 'product', label: 'Product Issues' },
            { id: 'payment', label: 'Payment & Refunds' },
            { id: 'account', label: 'Account' }
          ]);
        }

        // Then get FAQ items
        const querySnapshot = await getDocs(faqCollection);
        const faqData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setFaqQuestions(faqData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching FAQ data:', error);
        setError(error.message);
        setLoading(false);
      }
    };

    fetchFaqData();
  }, []);

  const toggleQuestion = (id) => {
    if (activeQuestion === id) {
      setActiveQuestion(null);
    } else {
      setActiveQuestion(id);
    }
  };

  if (loading) {
    return (
      <div className="faq-container loading-container">
        <div className="blog-header">
          <Link to="/" className="back-link">
            <FaArrowLeft /> Back to Home
          </Link>
        </div>
        <div className="loading-section">
          <div className="loading-spinner">
            <FaSpinner className="spinner-icon" />
          </div>
          <p>Loading FAQ content...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="faq-container error-container">
        <div className="blog-header">
          <Link to="/" className="back-link">
            <FaArrowLeft /> Back to Home
          </Link>
        </div>
        <div className="error-section">
          <h2>Error Loading Content</h2>
          <p>We're having trouble loading the FAQ content. Please try refreshing the page.</p>
          <button onClick={() => window.location.reload()}>Refresh Page</button>
        </div>
      </div>
    );
  }

  return (
    <div className="faq-container">
      <div className="blog-header">
        <Link to="/" className="back-link">
          <FaArrowLeft /> Back to Home
        </Link>
      </div>

      <div className="help-header">
        <h1>{faqSettings.title}</h1>
        <p>{faqSettings.subtitle}</p>
      </div>

      <div className="support-options">
        <div className="support-card">
          <h3>Call Us</h3>
          <div className="support-icon">
            <i className="phone-icon"></i>
          </div>
          <div className="support-contact">
            <p className="phone-number">{faqSettings.supportContacts.phone.number}</p>
            <p className="hours">{faqSettings.supportContacts.phone.hours}</p>
          </div>
        </div>

        <div className="support-card">
          <h3>Email Support</h3>
          <div className="support-icon">
            <i className="email-icon"></i>
          </div>
          <div className="support-contact">
            <p className="email">{faqSettings.supportContacts.email.address}</p>
            <p className="response-time">{faqSettings.supportContacts.email.response}</p>
          </div>
        </div>

        <div className="support-card">
          <h3>WhatsApp</h3>
          <div className="support-icon">
            <i className="whatsapp-icon"></i>
          </div>
          <div className="support-contact">
            <p className="phone-number">{faqSettings.supportContacts.whatsapp.number}</p>
            <p className="support-note">{faqSettings.supportContacts.whatsapp.note}</p>
          </div>
        </div>
      </div>

      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>

        <div className="faq-content">
          <div className="faq-categories">
            {faqCategories.map(category => (
              <div
                key={category.id}
                className={`category-item ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.label}
              </div>
            ))}
          </div>

          <div className="faq-questions">
            {faqQuestions.filter(q => q.category === activeCategory).length === 0 ? (
              <div className="no-questions-message">
                No questions available in this category.
              </div>
            ) : (
              faqQuestions
                .filter(q => q.category === activeCategory)
                .map((faq) => (
                  <div className="faq-item" key={faq.id}>
                    <div
                      className={`faq-question ${activeQuestion === faq.id ? 'active' : ''}`}
                      onClick={() => toggleQuestion(faq.id)}
                    >
                      <p>{faq.question}</p>
                      <span className="toggle-icon">{activeQuestion === faq.id ? '-' : '+'}</span>
                    </div>
                    {activeQuestion === faq.id && (
                      <div className="faq-answer">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </div>
                ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;